import type { Zippable } from 'fflate';

export interface ZipInstruction {
  files: Zippable;
  comment: string;
}

export async function zipFiles(
  files: { filename: string; data: Uint8Array<ArrayBufferLike> }[],
  comment: string
) {
  const worker = new Worker(new URL('./zip-worker.ts', import.meta.url), {
    type: 'module'
  });
  await new Promise<MessageEvent>(resolve =>
    worker.addEventListener('message', resolve, { once: true })
  );
  const zippable: Zippable = files.reduce((acc, { filename, data }) => {
    acc[filename] = data;
    return acc;
  }, {} as Zippable);
  worker.postMessage({ files: zippable, comment });
  const event = await new Promise<
    MessageEvent<
      | { type: 'zip-error' }
      | { type: 'zip-data'; data: Uint8Array<ArrayBuffer> }
    >
  >(resolve => worker.addEventListener('message', resolve, { once: true }));
  worker.terminate();
  if (event.data.type === 'zip-error') {
    throw new Error('Error creating ZIPs.');
  }
  return event.data.data;
}
